<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="
        (page) => {
          getParkListData().then((res) => {
            parkListData = res.data;
            onLoad(page);
          });
        }
      "
      @refresh-change="onLoad"
    >
      <template slot="status" slot-scope="scope">
        <el-tag :class="'client-status-class-' + scope.row.status"
          >{{ getstatus(scope.row.status) }}
        </el-tag>
      </template>
      <template slot="discountNumberForm" slot-scope="scope">
        <div>
          <el-input
            v-model="form.discountNumber"
            maxlength="10"
            style="width: 10rem"
            placeholder="请输入减免额度"
          ></el-input>
          <span v-if="form.discountType === 1"> 个月</span>
          <span v-if="form.discountType === 2"> 元</span>
          <span v-if="form.discountType === 3"> 折扣：原价为1，0.8即为8折优惠/8折</span>
        </div>
      </template>

      <template slot="menuLeft">
<!--        <el-button type="primary" icon="el-icon-plus" size="small" @click="addRecord">-->
<!--            新 增</el-button-->
<!--          >-->

        <!--<el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.carmonthchargerule_delete"
          @click="handleDelete"
          >删 除
        </el-button>-->
        <el-button
          type="primary"
          size="small"
          icon="el-icon-top"
          v-if="false"
          plain
          @click="monthCarChargeRuleSync"
          >收费规则同步
        </el-button>
      </template>

      <!-- <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-remove-outline"
          @click="disable(scope.row)"
          style="color: #ff0000"
        >停用
        </el-button>
      </template>-->
      <template slot="remark" slot-scope="scope">
        <wq-overHidden :content="scope.row.remark">
          <span>{{ scope.row.remark }}</span>
        </wq-overHidden>
      </template>
    </avue-crud>
    <hr-dialog title="新增" :allowFull="false" width="60%" :visible.sync="carMonthRuleFormVisible">
        <template slot="body">
          <carmonthRuleForm
            @cancle="recordCancle"

            v-if="addFormVisible"
            :row="canteenFormRow"
            @success="recordSuccess"

          ></carmonthRuleForm>
        </template>
      </hr-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  disable,
  removeFeeDetail,
  getParkList,
} from '@/api/v4ward/carv2/carmonthcutrule';
import { mapGetters } from 'vuex';
import carmonthRuleForm from './carmonthRuleForm.vue';
export default {
  components:{carmonthRuleForm},
  data() {
    var validateFeeInfos = (rule, value, callback) => {
      console.log('validateFeeInfos============>', value);
      console.log('isEmpty============>', this.vdui.isEmpty(value));

      if (this.vdui.isEmpty(value)) {
        callback(new Error('请输入减免额度！'));
        return;
      } else if (!this.$validation.money.test(value)) {
        callback(new Error('减免额度格式不正确！'));
        return;
      }
      callback();
    };
    var validateFeeInfos_ = (rule, value, callback) => {
      console.log('validateFeeInfos============>', value);
      console.log('isEmpty============>', this.vdui.isEmpty(value));

      if (this.vdui.isEmpty(value)) {
        callback(new Error('请输入缴费期数！'));
        return;
      } else if (!this.$validation.money.test(value)) {
        callback(new Error('缴费期数格式不正确！'));
        return;
      }
      callback();
    };
    return {
      addFormVisible:false,
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      parkListData: [],
      option: {
        dialogTop: 10,
        height: 'auto',
        sarchShow: true,
        searchMenuSpan: 12,
        calcHeight: 120,
        tip: false,
        indexLabel: '序号',
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        dialogWidth: '40%',
        dialogClickModal: false,
        column: [
          {
            label: '车场名称',
            type: 'tree',
            prop: 'spaceId',
            labelWidth: 120,
            searchLabelWidth: 100,
            searchValue: '',
            span: 24,
            search: true,
            searchClearable: false,
            // editDisplay: false,
            // viewDisplay: false,
            cell: true,
            props: {
              label: 'title',
              value: 'key',
            },
            rules: [
              {
                required: true,
                message: '请输入车场名称',
              },
            ],
            dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',
            change: (value, column) => {
              // this.generateRemark();
              console.log(value, column);
              this.query.spaceId = value;
            },
          },
          {
            label: '优惠规则',
            labelWidth: 120,
            searchLabelWidth: 100,
            prop: 'discountName',
            maxlength: 100,
            span: 24,
            search: true,
            rules: [
              {
                required: true,
                message: '请输入优惠规则名称',
              },
            ],
          },
          /*{
            label: '套餐类型',
            type: 'select',
            labelWidth: 120,
            dicUrl: '/api/blade-system/dict/dictionary?code=car_month_package',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            prop: 'packageType',
            search: true,
            rules: [
              {
                required: true,
                message: '请输入套餐类型',
              },
            ],
          },*/
          {
            label: '车辆类别',
            type: 'select',
            labelWidth: 120,
            dicUrl: '/api/blade-system/dict/dictionary?code=car_category_v2',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'string',
            prop: 'carCategory',
            // search: true,
            rules: [
              {
                required: true,
                message: '请输入车辆类别',
              },
            ],
            change: ({ value, column }) => {
              this.generateRemark();
            },
          },
          {
            label: '车辆类型',
            type: 'select',
            labelWidth: 120,
            dicUrl: '/api/blade-system/dict/dictionary?code=car_type_v2',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'string',
            prop: 'carType',
            // search: true,
            rules: [
              {
                required: true,
                message: '请输入车辆类型',
              },
            ],
            change: ({ value, column }) => {
              this.generateRemark();
            },
          },
          {
            label: '缴费期数(月)',
            prop: 'payPeriods',
            labelWidth: 120,
            type: 'number',
            // editDisplay: false,
            // addDisplay: false,
            // editDisabled: true,
            // addDisabled:true,
            rules: [
              // {
              //   required: true,
              //   message: '请输入缴费期数',
              //   trigger: 'change',
              // },
              { validator: validateFeeInfos_, trigger: 'change' },
            ],
          },

          {
            label: '减免类型',
            type: 'radio',
            labelWidth: 120,
            span: 24,
            // dicUrl: '/api/blade-system/dict/dictionary?code=car_type_v2',
            dicData: [
              { name: '减免月份', id: 1 },
              { name: '减免固定金额', id: 2 },
              { name: '优惠折扣', id: 3 },
            ],
            props: {
              label: 'name',
              value: 'id',
            },
            dataType: 'number',
            prop: 'discountType',
            // search: true,
            rules: [
              {
                required: true,
                message: '请输入减免类型',
              },
            ],
            change: ({ value, column }) => {
              this.generateRemark();
            },
          },

          {
            label: '减免',
            prop: 'discountNumber',
            labelWidth: 120,
            span: 24,
            align: 'right',
            // headerAlign:'right',
            headerAlign: 'right',
            type: 'number',
            formslot: true,
            // editDisplay: false,
            // addDisplay: false,
            // editDisabled: true,
            // addDisabled:true,
            rules: [
              // {
              //   required: true,
              //   message: '请输入减免额度',
              //   trigger: 'change',
              // },
              { validator: validateFeeInfos, trigger: 'change' },
            ],
          },

          {
            label: '备注',
            labelWidth: 120,
            prop: 'remark',
            type: 'textarea',
            slot: true,
            maxlength: 300,
            span: 24,
          },

        ],
      },
      data: [],
    };
  },
  watch: {

  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carmonthchargerule_add, false),
        viewBtn: this.vaildData(this.permission.carmonthchargerule_view, false),
        delBtn: this.vaildData(this.permission.carmonthchargerule_delete, false),
        editBtn: this.vaildData(this.permission.carmonthchargerule_edit, false),
        syncBtn: this.vaildData(this.permission.carmonthchargerule_sync, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    console.log();
    this.$nextTick(() => {
      setTimeout(() => {
        document
          .querySelector(
            '#avue-view  div.avue-crud > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)'
          )
          .addEventListener('click', () => {
            if (this.option.height == this.bodyHeight - 380) {
              this.option.height = this.bodyHeight - 300;
            } else {
              this.option.height = this.bodyHeight - 380;
            }
            this.$refs.crud.getTableHeight();
          });
      }, 1000);
    });
  },
  activated() {
    setTimeout(() => {
      this.$refs.crud.doLayout();
    });
  },
  methods: {
    getParkListData() {
      return getParkList();
    },
    calculableFee(row) {
      let feeInfos = row.feeInfos;
      let costPrice = 0;
      if (feeInfos.length > 0) {
        feeInfos.forEach((e) => {
          costPrice += parseFloat(e.itemPrice);
        });
      } else {
        costPrice = 0;
      }
      row.costPrice = costPrice.toFixed(2);
      row.spaceName = row.$spaceId;
      let costSortStr = row.$costSort;
      let spaceIdStr = row.$spaceId;
      if (this.vdui.isNotEmpty(row.costPrice)) {
        row.remark = spaceIdStr + costSortStr + '  ' + row.costPrice + '元';
      }
    },
    generateRemark() {
      // setTimeout(() => {
      //   let costSortStr = this.form.$costSort;
      //   let spaceIdStr = this.form.$spaceId;
      //   let costPrice = this.form.costPrice;
      //   if (this.vdui.isNotEmpty(costPrice)) {
      //     this.form.remark = spaceIdStr + costSortStr + '  ' + costPrice + '元';
      //   }
      // }, 0);
    },
    monthCarChargeRuleSync() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定同步月卡车收费规则到停车场?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return syncMonthCarChargeRules({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    rowSave(row, loading, done) {
      // this.calculableFee(row);
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      // this.calculableFee(row);
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    disable(row) {
      if (row.status == 0) {
        this.$message.warning(' 该条月卡车收费规制已停用！');
        return;
      }
      this.$confirm('是否选择停用套餐', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return disable({ id: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['add'].includes(type)) {
        this.form = {};
        this.form.discountType = 1;
        this.form.spaceId = this.$refs.crud.$refs.headerSearch.searchForm.spaceId;

        console.log(this.$refs.crud.$refs.headerSearch.searchForm.spaceId);
        console.log(this.form);
        console.log(this.$refs.crud.$refs);
      }
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
          this.form.carCategory = this.form.carCategory + '';
          this.form.carType = this.form.carType + '';
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      setTimeout(() => {
        this.$refs.crud.$refs.headerSearch.searchForm.spaceId =
          this.$refs.crud.$refs.headerSearch.searchForm.spaceId || this.parkListData[0].id;
        console.log(this.parkListData);
        this.query.spaceId = this.query.spaceId || this.parkListData[0].key;
        page = page || this.page;
        this.loading = true;
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
          }
        );
      });
    },
    getstatus(status) {
      if (status === 1) {
        return '启动';
      } else if (status === 0) {
        return '停用';
      } else {
        return '其他';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .avue-form__menu--center {
  text-align: right;
}
::v-deep .avue-crud__dialog .el-dialog__body {
  height: 50vh;
}
</style>
